import { useEffect} from 'react';
import useNotification from "./../../store/Notifications/useNotification";
import ToastNotification from './ToastNotification';
import ModalNotification from './ModalNotification';


function NortiifcationPopup() {
  const { 
    notification, 
    removeNotification,
    isNotificationVisible,
    setIsNotificationVisible,
  } = useNotification();
  
  const handleSubmit = () => {
    removeNotification();
    setIsNotificationVisible(false);
  };

  let notificationType: ToastNotificationProps["type"] = "warning"

  switch (notification.status) {
    case 200:
      notificationType = "success";
      break;
    case 400:
      notificationType = "danger";
      break;
    case 500:
      notificationType= "danger";
      break;
    default:
      break;
  }

  useEffect(() =>{

  }, [isNotificationVisible])

  if(!isNotificationVisible) return <></>; 

  return (
    <>
      {notification.diplayType === "Alert" &&
        <ToastNotification type={notificationType} message={notification.message} alertVisibility={handleSubmit} autoClose={true} autoCloseTime={5} />
      }
      {notification.diplayType === "Modal" &&
        <ModalNotification type={notificationType} message={notification.message} alertVisibility={handleSubmit} />
      }
    </>
  )
}

type ToastNotificationProps = React.ComponentProps<typeof ToastNotification>

export default NortiifcationPopup